import script from "./UnassignDevices.vue?vue&type=script&setup=true&lang=js"
export * from "./UnassignDevices.vue?vue&type=script&setup=true&lang=js"

import "./UnassignDevices.vue?vue&type=style&index=0&id=ee25c518&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ee25c518"]])

export default __exports__